var render = function render(){var _vm=this,_c=_vm._self._c;return _c('import',{attrs:{"props_to_send":_vm.props_to_send,"model_name":"provider_order","model_name_spanish":"articulos","pedir_operacion_a_realizar":false,"columns":_vm.columns}})
}
var staticRenderFns = []

export { render, staticRenderFns }